import { app } from './Api';

const uploadCronogramaAnual = async (file, unidadeId, ano, emailsCopia = []) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('unidade_id', unidadeId);
  formData.append('ano', ano);
  
  if (emailsCopia && emailsCopia.length > 0) {
    formData.append('emails_copia', JSON.stringify(emailsCopia));
  }

  return app.post('cronograma_anual', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

/**
 * Lista cronogramas anuais de manutenção
 * @param {number} ano - Ano do cronograma
 * @param {string} mes - Mês do cronograma (JAN, FEV, MAR, etc)
 * @param {number|string} unidadeId - ID da unidade (14725896312 = todas)
 * @returns {Promise}
 */
const listCronogramaAnual = async (ano = null, mes = null, unidadeId = null) => {
  const params = {};
  
  if (ano) {
    params.ano = ano;
  }
  
  if (mes) {
    params.mes = mes;
  }
  
  if (unidadeId && unidadeId !== '14725896312' && unidadeId !== '') {
    params.unidade_id = unidadeId;
  }

  return app.get('cronograma_anual', { params });
};

/**
 * Busca emails em cópia cadastrados para uma unidade e ano
 * @param {number|string} unidadeId - ID da unidade
 * @param {number} ano - Ano do cronograma
 * @returns {Promise}
 */
const getEmailsCopia = async (unidadeId, ano) => {
  const params = {
    unidade_id: unidadeId,
    ano: ano
  };

  return app.get('cronograma_anual/emails-copia', { params });
};

/**
 * Atualiza apenas a lista de emails em cópia (sem reenviar planilha)
 * @param {number|string} unidadeId
 * @param {number} ano
 * @param {string[]} emailsCopia
 * @returns {Promise}
 */
const updateEmailsCopia = async (unidadeId, ano, emailsCopia = []) => {
  return app.put('cronograma_anual/emails-copia', {
    unidade_id: unidadeId,
    ano,
    emails_copia: emailsCopia
  });
};

export { uploadCronogramaAnual, listCronogramaAnual, getEmailsCopia, updateEmailsCopia };
